import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useDispatch } from 'react-redux';
import { setPreferenceCenterOpen } from '@/redux/cookieSlice';

export const ListsyncFooter: React.FC = () => {
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <footer
      style={{
        backgroundColor: '#f9fafb',
        color: '#4b5563',
        padding: isMobile ? '40px 20px' : '60px 40px'
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Top Section: Logo and Links */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: isMobile ? 'flex-start' : 'center',
            marginBottom: isMobile ? '24px' : '40px',
            flexWrap: 'wrap',
            gap: '20px',
            flexDirection: isMobile ? 'column' : 'row'
          }}
        >
          <div>
            <Image
              src="/listsync/listsync-logo.svg"
              alt="Listsync Logo"
              width={isMobile ? 120 : 140}
              height={isMobile ? 41 : 48}
              style={{ height: 'auto' }}
            />
          </div>
          {isMobile ? (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '40px',
                width: '100%',
                marginTop: '20px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}
              >
                <Link
                  href="#"
                  style={{
                    textDecoration: 'none',
                    color: '#1a1a1a',
                    fontWeight: 500,
                    fontSize: '16px'
                  }}
                >
                  Home
                </Link>
                <Link
                  href="#pricing"
                  style={{
                    textDecoration: 'none',
                    color: '#1a1a1a',
                    fontWeight: 500,
                    fontSize: '16px'
                  }}
                >
                  Pricing
                </Link>
                <Link
                  href="#"
                  style={{
                    textDecoration: 'none',
                    color: '#1a1a1a',
                    fontWeight: 500,
                    fontSize: '16px'
                  }}
                >
                  Support
                </Link>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px'
                }}
              >
                <Link
                  href="#why"
                  style={{
                    textDecoration: 'none',
                    color: '#1a1a1a',
                    fontWeight: 500,
                    fontSize: '16px'
                  }}
                >
                  About
                </Link>
                <Link
                  href="/terms"
                  style={{
                    textDecoration: 'none',
                    color: '#1a1a1a',
                    fontWeight: 500,
                    fontSize: '16px'
                  }}
                >
                  Terms & Privacy
                </Link>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                gap: '24px',
                alignItems: 'center',
                fontSize: '14px',
                color: '#4b5563',
                flexWrap: 'wrap',
                justifyContent: 'flex-end'
              }}
            >
              <Link
                href="/terms"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                Website T&C
              </Link>
              <span>|</span>
              <Link
                href="/privacy"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                Privacy Policy
              </Link>
              <span>|</span>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(setPreferenceCenterOpen(true));
                }}
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  cursor: 'pointer'
                }}
              >
                Cookie policy
              </a>
            </div>
          )}
        </div>

        {/* Divider */}
        <div
          style={{
            height: '1px',
            backgroundColor: '#e5e7eb',
            marginBottom: isMobile ? '24px' : '40px'
          }}
        />

        {/* Bottom Section: Legal and Copyright */}
        <div
          style={{
            display: 'flex',
            justifyContent: isMobile ? 'center' : 'space-between',
            alignItems: isMobile ? 'center' : 'flex-start',
            flexWrap: 'wrap',
            gap: isMobile ? '20px' : '40px',
            fontSize: isMobile ? '12px' : '13px',
            lineHeight: '1.6',
            color: '#6b7280',
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'left' : 'left'
          }}
        >
          <div style={{ maxWidth: isMobile ? '100%' : '600px' }}>
            <p style={{ margin: 0 }}>
              NESTFLO LIMITED trading Listsync is registered in England and
              Wales under registration number 13908049. The registered address
              is Unit 111, Filwood Green Business Park, 1 Filwood Park Lane,
              Bristol, England, BS4 1ET, United Kingdom
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              gap: isMobile ? '12px' : '20px',
              alignItems: 'center',
              whiteSpace: isMobile ? 'normal' : 'nowrap',
              flexDirection: 'row',
              justifyContent: isMobile ? 'space-between' : 'flex-start',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            <span>© 2025 NESTFLO LIMITED</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>Proudly built in the UK</span>
              <span>🇬🇧</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
